import { CommonModule } from "@angular/common";
import { Component, input, OnInit, output } from "@angular/core";
import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
import { map, Observable } from "rxjs";

import { IconModule } from "@shared/components/icon/icon.module";
import { Payout, Transaction, TransactionPagination } from "@shared/models/payouts.types";
import { PipesModule } from "@shared/pipes/pipes.module";
import { PayoutsService } from "@shared/services/payouts/payouts.service";

@Component({
	selector: "app-deductions-data",
	standalone: true,
	imports: [CommonModule, MatTableModule, IconModule, PipesModule],
	templateUrl: "./deductions-data.component.html",
	styleUrl: "./deductions-data.component.scss"
})
export class DeductionsDataComponent implements OnInit {
	payout = input.required<Payout>();
	totalDeductionAmount = output<number>();

	deductions: Transaction[] = [];
	displayedColumns: string[] = ["date", "paymentMethod", "amount", "type"];
	totalDeductionPayment = 0;
	totalPayment = 0;

	constructor(private payoutsService: PayoutsService) {}

	ngOnInit(): void {
		this.getPayoutsDeductions([this.payout().employee.id!], [this.payout().payCycleId]).subscribe(deduction => {
			this.deductions = deduction;

			this.deductions.forEach(deduction => {
				this.totalDeductionPayment += deduction.amount.value;
			});

			this.totalDeductionAmount.emit(this.totalDeductionPayment);
		});
	}

	getPayoutsDeductions(employeeIds: Array<string>, payCycleIds: Array<string>): Observable<Transaction[]> {
		return this.payoutsService.searchPayoutsDeductions(employeeIds, payCycleIds).pipe(
			map((response: TransactionPagination) => {
				return response.items;
			})
		);
	}
}
